module.exports = __webpack_public_path__ + "img/server1.d540316a.png";